import {
  Autocomplete,
  Burger,
  Button,
  Container,
  Group,
  Menu,
  NavLink,
} from "@mantine/core";
import {
  IconBrandLine,
  IconBroadcast,
  IconFileOrientation,
  IconLogin,
} from "@tabler/icons-react";
import { useDisclosure, useWindowScroll } from "@mantine/hooks";

import "./styles.scss";
import { Colors, LogoFull } from "../../../Lib/Data";

import { Link } from "react-router-dom";

const links = [
  { link: "/d/services", label: "Services", icon: IconBroadcast },
  {
    link: "#works",
    label: "How it Works",
    id: true,
    icon: IconFileOrientation,
  },
  { link: "#contact", label: "Contact Us", id: true, icon: IconBrandLine },
];

export default function HomeNav({
  useBlogColorScheme,
}: {
  useBlogColorScheme?: boolean;
}) {
  const [opened, { toggle }] = useDisclosure(false);
  const [scroll, scrollTo] = useWindowScroll();

  const items = links.map((link) => {
    return link.id ? (
      <a
        href={link.link}
        className={`link ${scroll.y > 10 ? "link-scrolled" : ""} ${
          useBlogColorScheme ? "link-blog" : ""
        }`}
      >
        {link.label}
      </a>
    ) : (
      <Link
        key={link.label}
        to={link.link}
        className={`link ${scroll.y > 10 ? "link-scrolled" : ""} ${
          useBlogColorScheme ? "link-blog" : ""
        }`}
      >
        {link.label}
      </Link>
    );
  });

  const [isNavOpened, { toggle: ToggleNav, close: CloseNav }] =
    useDisclosure(false);
  return (
    <div className="home-nav-container">
      <header className={`header ${scroll.y > 10 ? "header-scrolled" : ""}`}>
        <Container size="lg">
          <div className={"inner"}>
            <Group>
              <Link
                to="/"
                onClick={() => {
                  scrollTo({
                    x: 0,
                    y: 0,
                  });
                }}
              >
                <img src={LogoFull} alt="" className="logo" />
              </Link>
            </Group>
            <Group ml={50} gap={5} className={"large-links"}>
              {items}
            </Group>
            <div className="nav-cta">
              <Link to="/login">
                <Button
                  size="md"
                  radius="xl"
                  variant="gradient"
                  gradient={{
                    from: Colors.GreenPrimary,
                    to: Colors.BluePrimary,
                  }}
                >
                  Get Started
                </Button>
              </Link>
            </div>
            <Menu
              shadow="md"
              width={300}
              opened={isNavOpened}
              onClose={CloseNav}
            >
              <Menu.Target>
                <Burger
                  className="burger"
                  color={
                    useBlogColorScheme
                      ? Colors.GreenPrimary
                      : scroll.y > 10
                      ? Colors.GreenSecondary
                      : Colors.WhiteBlueTransparent
                  }
                  opened={isNavOpened}
                  onClick={ToggleNav}
                />
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>Menu</Menu.Label>
                <Menu.Divider />
                {links.map((link) => {
                  return link.id ? (
                    <a href={link.link}>
                      <NavLink
                        leftSection={<link.icon size={18} />}
                        c={Colors.BluePrimary}
                        label={link.label}
                      />
                    </a>
                  ) : (
                    <Link to={link.link}>
                      <NavLink
                        leftSection={<link.icon size={18} />}
                        c={Colors.BluePrimary}
                        label={link.label}
                      />
                    </Link>
                  );
                })}
                <Menu.Divider />

                <Link to="/login">
                  <NavLink
                    leftSection={<IconLogin size={18} />}
                    c={Colors.GreenPrimary}
                    label="Login"
                  />
                </Link>
              </Menu.Dropdown>
            </Menu>
          </div>
        </Container>
      </header>
    </div>
  );
}
